import { request } from '@umijs/max'

/**
 获取TMDB的URL GET https://gushi.zeabur.app/tmdb/${path}
 */
export async function getTmdb(params: { path: string }) {
  return request<any>(`https://gushi.zeabur.app/tmdb/${params.path}`, { method: 'GET', params })
}

export async function getBgm(params: { path: string }) {
  return request<any>(`https://gushi.zeabur.app/bgm/${params.path}`, { method: 'GET', params })
}

export async function getBiliInfo(params: { id: string }) {
  return request<any>(`https://gushi.zeabur.app/biliinfo/${params.id}`, { method: 'GET', params })
}

/** 获取MAL的URL GET https://gushi.zeabur.app/mal/${id} */
export async function getMal(params: { id: string | number }) {
  return request<any>(`https://gushi.zeabur.app/mal/${params.id}`, { method: 'GET', params })
}

export async function getDouban(params: { id: string | number }) {
  return request<any>(`https://gushi.zeabur.app/douban/${params.id}`, { method: 'GET', params })
}

export async function getImdb(params: { id: string | number }) {
  return request<any>(`https://gushi.zeabur.app/imdb/${params.id}`, { method: 'GET', params })
}

/** 获取AniList的URL GET https://gushi.zeabur.app/anilist/${id} */
export async function getAnilist(params: { id: string | number }) {
  return request<any>(`https://gushi.zeabur.app/anilist/${params.id}`, { method: 'GET', params })
}

export async function postBgm(body?: any, options?: Record<string, any>) {
  return request<any>('/backend/video/bgmApi', {
    method: 'POST',
    data: body,
    ...options
  })
}
